<template>
    <div class="inner-container forecast-reporting">
        <div class="section-title budget"><i class="icon icon-calculator-coins"></i><span>Бюджетное планирование</span>
        </div>
        <div class="section-subtitle"><i class="icon icon-grid"></i><span>Прогнозная консолидированная финансовая отчетность</span>
        </div>
        <b-tabs v-model="activeTab">
            <b-tab v-if="abp_level && abpTab" title="ПКФО АБП">
                <ForecastAbp
                    :access_level="access_level"
                    :abp_cons="abp_cons"
                    :condition3="condition3"
                    @update-forecast-props="setForecastParams"
                    @update-root-view="isRootView = $event"></ForecastAbp>
            </b-tab>
            <b-tab v-if="obl_level && oblTab" title="ПКФО УО">
                <ForecastUO
                    :access_level="access_levelObl"
                    @update-forecastuo-props="setForecastParams"
                    @update-root-view="isRootViewUO = $event"></ForecastUO>
            </b-tab>
        </b-tabs>
        <div class="actions-tab in-tab">
            <b-dropdown v-if="isRootView && activeTab === 0"
                        variant="link" right toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <i class="icon icon-download"></i> Скачать
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-item @click="downloadRep">Межформенная сверка</b-dropdown-item>
            </b-dropdown>
            <b-dropdown v-if="isRootViewUO && activeTab === 1"
                        variant="link" right toggle-class="text-decoration-none" no-caret :disabled="isReportFormed">
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <i class="icon icon-download"></i> Скачать
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-item @click="downloadRepUO">Межформенная сверка</b-dropdown-item>
            </b-dropdown>
            <b-dropdown variant="link" class="info" right toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <i class="icon icon-info"></i>
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-text>
                    <div class="info-button">
                        <span @click="infoForm">Режим "ПКФО"<i class="icon icon-folder"></i></span>
                    </div>
                    <div class="info-button">
                        <a href="https://www.youtube.com/watch?v=wM_FcyTktEY&t=12s" target="_blank"><span>Видеоинструкция<i
                            class="icon icon-video"></i></span></a>
                    </div>
                    <div class="info-text">
                        <p>Данный раздел содержит информацию по ПКФО в соответствии с Приказом МФ РК от
                            24 апреля 2025 года № 192 «Об утверждении Правил составления прогнозной
                            консолидированной финансовой отчетности администратора бюджетных программ»</p>
                    </div>
                </b-dropdown-text>
            </b-dropdown>
        </div>
    </div>
</template>

<script>
import ForecastAbp from "@/modules/forecast-reporting/ForecastAbp";
import ForecastUO from "@/modules/forecast-reporting/ForecastUO";
import {Ax} from "@/utils";
import axios from "axios";

export default {
    components: {ForecastAbp, ForecastUO},
    name: 'forecast-reporting',
    data() {
        return {
            abpTab: false,
            oblTab: false,
            abp_level: false,
            obl_level: false,
            abp_cons: false,
            access_level: 1,
            access_levelObl: 1,
            access_uo: false,
            access_abp: false,
            workplace: false,
            forecastParams: {},
            isRootView: true,
            isRootViewUO: true,
            activeTab: 0,
            isLoad: false,
            isReportFormed: false,
        }
    },
    async mounted() {
        await this.getAccessLevelABP();
        await this.getPkfoAbpAccess();
        await this.getPkfoAbpAccessCons();
        await this.getAccessLevelObl();
        await this.getPkfoOblAccess();
    },
    computed: {
        condition3() {
            return this.access_uo && this.access_abp && this.workplace;
        }
    },
    methods: {
        async getPkfoAbpAccess() {
            try {
                const response = await fetch(`/api-py/get_access_by_user_id_to_pkfo/${this.$store.getters.user_uuid}`);
                const abp_pkfo = await response.json();
                if (abp_pkfo.length > 0) {
                    this.abpTab = true;
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса pkfo_abp', error.toString());
            }
        },
        async getPkfoAbpAccessCons() {
            try {
                const response = await fetch(`/api-py/get_access_by_user_id_to_pkfo_cons/${this.$store.getters.user_uuid}`);
                const abp_pkfo = await response.json();
                if (abp_pkfo.length > 0) {
                    this.abpTab = true;
                    this.oblTab = true;
                    this.abp_cons = true;
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса pkfo_abp', error.toString());
            }
        },
        async getAccessLevelABP() {
            try {
                const response = await fetch(`/api-py/user-modules/${this.$store.getters.user_uuid}/004.009.001`);

                const modules_access = await response.json();
                if (modules_access.length > 1) {
                    this.makeToast("danger", "Ошибка", "У пользователя несколько записей")
                }
                if (modules_access.length === 0) {
                    this.access_level = 1;
                } else {
                    for (const ma of modules_access) {
                        this.access_level = ma.access_level;
                        this.access_abp = true;
                        this.abp_level = true;
                    }
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса load_user_access_level', error.toString());
            }
        },
        async getAccessLevelObl() {
            try {
                const response = await fetch(`/api-py/user-modules/${this.$store.getters.user_uuid}/004.009.002`);

                const modules_access = await response.json();
                if (modules_access.length > 1) {
                    this.makeToast("danger", "Ошибка", "У пользователя несколько записей")
                }
                if (modules_access.length === 0) {
                    this.access_levelObl = 1;
                } else {
                    for (const ma of modules_access) {
                        this.access_levelObl = ma.access_level;
                        this.obl_level = true;
                        this.access_uo = true;
                    }
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса load_user_access_level', error.toString());
            }
        },
        async getPkfoOblAccess() {
            try {
                const response = await fetch(`/api-py/get_uo_access_by_user_id/${this.$store.getters.user_uuid}`);
                const uo_pkfo = await response.json();
                if (uo_pkfo.length > 0) {
                    this.oblTab = true;
                    this.workplace = true;
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса pkfo_uo', error.toString());
            }
        },
        setForecastParams(params) {
            this.forecastParams = params;
        },
        downloadRep() {
            try {
                this.makeToast('info', 'Внимание!', 'Скоро начнется скачивание. Пожалуйста ожидайте.');
                this.isLoad = true;
                this.curParams = {...this.forecastParams};
                Ax(
                    {
                        url: '/api-py/check_data_for_forecast_download/' + JSON.stringify(this.curParams),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Межформенная сверка.xlsx');
                        document.body.appendChild(link);
                        link.click();
                    },
                    (error) => {
                        this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                    }
                );
            } catch (error) {
                console.log(error)
                this.makeToast('danger', 'Предупреждение', 'Необходимо заполнить все обязательные фильтры!');
            } finally {
                this.isLoad = false
            }
        },
        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        },
        downloadRepUO() {
            try {
                this.makeToast('info', 'Внимание!', 'Скоро начнется скачивание. Пожалуйста ожидайте.');
                this.isLoad = true;
                this.isReportFormed = true;
                this.curParams = {...this.forecastParams};
                Ax(
                    {
                        url: '/api-py/check_data_for_uo_forecast_download/' + JSON.stringify(this.curParams),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Межформенная сверка.xlsx');
                        document.body.appendChild(link);
                        link.click();
                        this.isReportFormed = false;
                    },
                    (error) => {
                        this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                    }
                );
            } catch (error) {
                console.log(error)
                this.makeToast('danger', 'Предупреждение', 'Необходимо заполнить все обязательные фильтры!');
            } finally {
                this.isLoad = false
            }
        },
        async infoForm() {
            if (this.isLoad) {
                this.makeToast('info', 'Внимание', 'Скоро начнется скачивание. Пожалуйста ожидайте.');
            } else {
                this.isLoad = true;
                await axios({
                    method: 'post',
                    url: '/api-py/get-info/40',
                    responseType: 'blob',
                    data: null
                })
                    .then((response) => response.data)
                    .then((data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        const titleOfFile = 'Инструкция ПКФО_АБП_УО';
                        link.setAttribute('download', titleOfFile + '.pdf');// or any other extension
                        document.body.appendChild(link);
                        link.click();
                        // handle success
                    })
                    .catch((error) => {
                        console.log(error);
                        this.makeToast('danger', 'Ошибка запроса infoCostForm()', error.toString());
                    })
                    .finally(() => {
                        this.isLoad = false;
                    });
            }
        },
    }
}
</script>
